(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ozoric-before-after"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ozoric-image-comparison')) {
    customElements.define('ozoric-image-comparison', class extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input[type="range"]');
        if (!this.input) return;
        this.onInput = () => {
          const value = Math.max(0, Math.min(100, Number(this.input.value)));
          this.style.setProperty('--comparison-position', `${value}%`);
          this.input.setAttribute('aria-valuetext', `${this.dataset.beforeLabel}: ${value}%, ${this.dataset.afterLabel}: ${100 - value}%`);
        };
        this.input.addEventListener('input', this.onInput);
        this.onInput();
      }

      disconnectedCallback() {
        this.input?.removeEventListener('input', this.onInput);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ozoric-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ozoric-footer-localization')) {
    customElements.define('ozoric-footer-localization', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.addEventListener('change', (event) => {
          const select = event.target;
          if (!(select instanceof HTMLSelectElement)) return;
          select.form?.requestSubmit();
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ozoric-home-featured"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ozoric-home-featured')) {
    customElements.define('ozoric-home-featured', class extends HTMLElement {
      connectedCallback() {
        if (this.onVariantChange) return;
        this.onVariantChange = (event) => {
          if (!event.target.matches('[data-featured-variant]')) return;
          this.updateVariant(event.target.selectedOptions[0]);
        };
        this.onAddSubmit = (event) => {
          if (event.submitter && event.submitter.name !== 'add') return;
          event.preventDefault();
          this.addToCart(event.target);
        };
        this.addEventListener('change', this.onVariantChange);
        this.addEventListener('submit', this.onAddSubmit);
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onVariantChange);
        this.removeEventListener('submit', this.onAddSubmit);
        this.onVariantChange = null;
        this.onAddSubmit = null;
      }

      updateVariant(option) {
        if (!option) return;
        const price = this.querySelector('[data-featured-price]');
        const compare = this.querySelector('[data-featured-compare]');
        const submit = this.querySelector('[data-featured-submit]');
        const payment = this.querySelector('[data-featured-payment]');
        const quantity = this.querySelector('[data-featured-quantity]');
        const available = option.dataset.available === 'true';
        if (price) price.textContent = option.dataset.price;
        if (compare) {
          compare.textContent = option.dataset.compare;
          compare.hidden = !option.dataset.compare;
        }
        if (submit) {
          submit.dataset.available = String(available);
        }
        if (payment) payment.hidden = !available;
        if (quantity) {
          const min = Number(option.dataset.min) || 1;
          const step = Number(option.dataset.step) || 1;
          const max = Number(option.dataset.max) || Infinity;
          const current = Number(quantity.value) || min;
          let next = min + Math.max(0, Math.ceil((current - min) / step)) * step;
          if (next > max) next = min + Math.floor((max - min) / step) * step;
          quantity.min = String(min);
          quantity.step = String(step);
          if (Number.isFinite(max)) quantity.max = String(max);
          else quantity.removeAttribute('max');
          quantity.value = String(Math.max(min, next));
        }
        this.refreshControls();
      }

      refreshControls() {
        const locked = Boolean(this.pending || this.uncertain);
        const submit = this.querySelector('[data-featured-submit]');
        const form = this.querySelector('form');
        const payment = this.querySelector('[data-featured-payment]');
        if (form) form.setAttribute('aria-busy', String(Boolean(this.pending)));
        if (submit) {
          const available = submit.dataset.available === 'true';
          submit.disabled = locked || !available;
          submit.textContent = this.pending ? submit.dataset.addingLabel : available ? submit.dataset.availableLabel : submit.dataset.unavailableLabel;
        }
        this.querySelectorAll('[data-featured-variant], [data-featured-quantity]').forEach(control => {
          control.disabled = locked;
        });
        if (payment) payment.inert = locked;
      }

      showStatus(message) {
        const status = this.querySelector('[data-featured-status]');
        if (!status) return;
        status.querySelector('[data-featured-status-text]').textContent = message;
        status.hidden = !message;
        if (message) status.focus();
      }

      async addToCart(form) {
        if (this.pending || this.uncertain || !form.reportValidity()) return;
        const data = new FormData(form);
        const variantId = String(data.get('id') || '');
        const quantity = Number(data.get('quantity'));
        const submit = this.querySelector('[data-featured-submit]');
        if (!variantId || !Number.isInteger(quantity) || quantity < 1 || submit?.dataset.available !== 'true') return;
        this.pending = true;
        this.showStatus('');
        this.refreshControls();
        const request = new AbortController();
        const timeout = setTimeout(() => request.abort(), 30000);
        let attemptedAdd = false;
        try {
          const { addNativeCartItems } = await import('@theme/ozoric-cart-actions');
          attemptedAdd = true;
          await addNativeCartItems({
            source: this,
            items: [{ id: variantId, quantity }],
            cartAddUrl: this.dataset.cartAddUrl,
            cartUrl: this.dataset.cartUrl,
            productId: this.dataset.productId,
            signal: request.signal
          });
        } catch (error) {
          this.uncertain = attemptedAdd && error?.uncertain !== false;
          this.showStatus(this.uncertain ? this.dataset.uncertainLabel : this.dataset.errorLabel);
        } finally {
          clearTimeout(timeout);
          this.pending = false;
          this.refreshControls();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
